import React from 'react';
import Icon from '../../../components/AppIcon';

const SupplySummaryPanel = ({ summary }) => {
  const metrics = [
    {
      label: 'Total Peternak',
      value: summary?.totalSuppliers,
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      label: 'Volume Total Harian',
      value: `${summary?.totalDailyVolume?.toLocaleString('id-ID')} L`,
      icon: 'Droplet',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      label: 'Rata-rata Kualitas',
      value: `${summary?.averageQuality}%`,
      icon: 'Award',
      color: 'text-success',
      bgColor: 'bg-success/10',
    },
    {
      label: 'Konsistensi Pasokan',
      value: `${summary?.supplyConsistency}%`,
      icon: 'TrendingUp',
      color: summary?.supplyConsistency >= 80 ? 'text-success' : summary?.supplyConsistency >= 60 ? 'text-warning' : 'text-error',
      bgColor: summary?.supplyConsistency >= 80 ? 'bg-success/10' : summary?.supplyConsistency >= 60 ? 'bg-warning/10' : 'bg-error/10',
    },
  ];

  const warnings = [
    {
      id: 1,
      type: 'critical',
      message: `${summary?.criticalSuppliers} peternak dengan status kritis`,
      icon: 'AlertTriangle',
    },
    {
      id: 2,
      type: 'warning',
      message: `${summary?.warningSuppliers} peternak perlu perhatian`,
      icon: 'AlertCircle',
    },
    {
      id: 3,
      type: 'info',
      message: `Ketergantungan tinggi pada ${summary?.topSupplierPercentage}% peternak utama`,
      icon: 'Info',
    },
  ];

  return (
    <div className="space-y-6">
      <div className="bg-card rounded-xl border border-border p-4 md:p-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">Ringkasan Pasokan</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {metrics?.map((metric, index) => (
            <div key={index} className="bg-muted/30 rounded-lg p-4">
              <div className="flex items-center gap-3 mb-2">
                <div className={`w-10 h-10 rounded-lg ${metric?.bgColor} flex items-center justify-center`}>
                  <Icon name={metric?.icon} size={20} className={metric?.color} />
                </div>
                <span className="text-sm text-muted-foreground">{metric?.label}</span>
              </div>
              <p className={`text-xl md:text-2xl font-bold ${metric?.color} data-text`}>{metric?.value}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-xl border border-border p-4 md:p-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="AlertTriangle" size={20} color="var(--color-warning)" />
          Peringatan Kritis
        </h3>
        <div className="space-y-3">
          {warnings?.map((warning) => (
            <div
              key={warning?.id}
              className={`flex items-start gap-3 p-3 rounded-lg ${
                warning?.type === 'critical' ?'bg-error/10 border border-error/20'
                  : warning?.type === 'warning' ?'bg-warning/10 border border-warning/20' :'bg-primary/10 border border-primary/20'
              }`}
            >
              <Icon
                name={warning?.icon}
                size={18}
                color={
                  warning?.type === 'critical' ?'var(--color-error)'
                    : warning?.type === 'warning' ?'var(--color-warning)' :'var(--color-primary)'
                }
              />
              <p className="text-sm text-foreground flex-1">{warning?.message}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-xl border border-border p-4 md:p-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">Distribusi Regional</h3>
        <div className="space-y-3">
          {summary?.regionalDistribution?.map((region, index) => (
            <div key={index}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-foreground">{region?.name}</span>
                <span className="text-sm font-medium text-foreground data-text">{region?.count} peternak</span>
              </div>
              <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full bg-primary transition-all duration-300"
                  style={{ width: `${region?.percentage}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SupplySummaryPanel;